// extracted by mini-css-extract-plugin
export default {"container":"Vvv7m_cSIeyrumnpHdaM","customText":"wwXYI3tfcyCOI2tcPYQy"};